// ============================================================================
// IntegrationReadinessDoor — the one door to the integration readiness view
// (docs/PLAN-integration-readiness-engine-20261009.md, M1). The Activity page ships inside the first download
// (App.tsx imports it eagerly), and this view exists for one organisation's engineers, so it is its own
// on-demand chunk: fetched only when the page is scoped to Prest0 Inc., rendered only when the server says
// this person may see it.
//
// useDeferredModule, never React.lazy (see that hook's header for why).
// ============================================================================

import React from 'react';
import { useDeferredModule } from '../../utils/useDeferredModule';

interface Props {
  accountId: string;
  refreshKey?: number;
}

const IntegrationReadinessDoor: React.FC<Props> = ({ accountId, refreshKey }) => {
  const { module } = useDeferredModule(
    () => import(/* webpackChunkName: "integration-readiness" */ './IntegrationReadinessPanel'),
    'integration-readiness',
    { start: 'mount' },
  );
  if (!module) return null;
  const Panel = module.default;
  return <Panel accountId={accountId} refreshKey={refreshKey} />;
};

export default IntegrationReadinessDoor;
